<template>
<main class="bg-main lesson-quiz lesson-multiaudio">
  <contenthead :section="sectionData" :lesson="lessonData"></contenthead>

  <section class="container">

     <div class="heading-content-title">{{ $t('lesson.introduction.title') }}</div>

      <lessonmultiaudio v-if="introductionData.content.slide && audioType" :key="$route.params.lesson_id" :audioList="introductionData.content.slide" :audioType="audioType" @playevent="audioPlayEvent"></lessonmultiaudio>

      <div class="buttons-side-by-side">
        <a class="button button-default back" @click="back">{{ $t('common.button.back') }}</a>
        <a class="button button-primary next" @click="nextStep">{{ $t('common.button.next') }}</a>
      </div>

  </section>

</main>

</template>

<script>
import {api, appEnv} from './../../config';
import learningLog from '../../mixins/learning-log';
import status from '../../mixins/status';
import {mapState} from 'vuex'
import componentContentHead from '../shared/ContentHead.vue';
import LessonMultiAudio from './LessonMultiAudio.vue'

export default {
  name: 'LessonIntroduction',
  mixins: [
    learningLog,
    status
  ],
  components: {
    'contenthead': componentContentHead,
    'lessonmultiaudio': LessonMultiAudio,
  },
  data () {
    return {
      step: 'introduction',
      audioType: 'slide',
      authUser: null,
      storage: {}
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth
    }),
    sectionData() {
      return this.$store.getters.section_data;
    },
    lessonData() {
      return this.$store.getters.lesson_data;
    },
    introductionData() {
      return this.$store.getters.lesson_content.introduction ? this.$store.getters.lesson_content.introduction : {content: { title: '', body: ''}}
    },
  },
  // 1. 初回読み込み時
  async created() {
    this.authUser = this.$store.getters.getAuthUser;
    await this.initLoad();
  },
  mounted() {
  },
  methods: {
    // 3. 【追加】データ読み込みの初期化処理を共通化
    async initLoad() {
      this.$store.dispatch("showLoading", true);
      
      // ★重要：APIを叩く前に古いデータをクリアすることで、一瞬古い情報が残るのを防ぐ
      this.$store.dispatch('unsetLessonContent'); 
      
      await this.getSections();
    },

    async getSections () {
      let self = this;
      let userLevel = self.$store.getters.getAuthUser && self.$store.getters.getAuthUser.method_level ? self.$store.getters.getAuthUser.method_level.toLowerCase() : 'n5'
      
      return await axios.get(api.section + '?level=' + userLevel, { withCredentials: true })
      .then(async (resp) => {
        self.$store.dispatch("setSection", resp.data.section);
        await self.getLessons()
      })
      .catch(err => {
        self.$store.dispatch("showLoading", false);
      });
    },

    async getLessons () {
      let self = this;
      return await axios.get(api.lessons, {
        withCredentials: true,
        params: {
          lesson_id: self.$route.params['lesson_id'],
          section_status: self.$store.getters.section_status ? self.$store.getters.section_status : 0
        }
      })
      .then(async (resp) => {
        self.$store.dispatch('setLessons',  resp.data)
        self.$store.dispatch('showLoading', false)

        if(self.$route.params && self.$route.params['lesson_id']) {
          const rowLesson = self.$store.getters.lessons.find(item => {
              return item.lesson_id == self.$route.params['lesson_id']
          })

          if(rowLesson) {
            let sectionDataKeys = Object.keys(self.$store.getters.section)
            if(sectionDataKeys.length) {
              for(let regionName of sectionDataKeys) {
                  let sectionKeyData = self.$store.getters.section[regionName]
                  if(sectionKeyData && sectionKeyData.section_id == rowLesson.section_id) {
                      self.$store.dispatch('setSectionData', sectionKeyData);
                      self.$store.dispatch("setSectionStatus", sectionKeyData.status);
                      if (sectionKeyData.status == "incomplete" || sectionKeyData.status == "ready") {
                        self.statusSection('start');
                      }
                      break;
                  }
              }
            }
            self.$store.dispatch('setLessonData', rowLesson);
            self.$store.dispatch("setLessonStatus", rowLesson.status);

            await self.getContents()
          }
        }
      })
      .catch(err => {
        self.$store.dispatch("showLoading", false);
      });
    },

    async getContents () {
      let self = this;
      return await axios.get(api.contents, {
        params: {
          lesson_id: this.$store.getters.lesson_data.lesson_id,
          lesson_type: this.$store.getters.lesson_data.lesson_type
        }
      })
      .then((resp) => {
        // ※ ここにあった unsetLessonContent は initLoad に移動したため削除
        this.$store.dispatch('setLessonContent',  resp.data)
        this.$store.dispatch('showLoading', false)
      })
      .catch(err => {
        this.$store.dispatch("showLoading", false);
      });
    },

    nextStep() {
      if (this.$store.getters.lesson_content[this.step].status != 'completed') {
        this.statusContent('completed', this.step);
        this.$store.dispatch('updateLessonContentStatus', {type: 'introduction', status: 'completed' });
      }
      this.learningTempLog();
      this.learningLog();
      this.$router.push({name: 'lesson.grammar'});
    },
    back() {
      return window.location.href = this.$store.getters.section_data.section_id ? `${window.global.jsl_front_url}/method/?section_id=${this.$store.getters.section_data.section_id}` : `${window.global.jsl_front_url}/method`
    },
    audioPlayEvent: function(value) {
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 900px) {
  .maxWidth {
    width: 100%;
  }
}
</style>
